import { ElementType } from 'react';
import styled from '@emotion/styled';
import { Colors } from '../../Colors';
import { css } from '@emotion/react';

const propView = ['blue', 'gray'] as const;
type PropView = typeof propView[number];

export interface LinkProps {
  as?: ElementType;
  to?: string;
  onClick?: (e: React.SyntheticEvent) => void;
  weight?: 'regular' | 'bold';
  view?: PropView;
}

const LinkText = styled('a')<LinkProps>`
  font-weight: ${props => props.weight === 'bold' && '700'};
  color: ${props => (props.view === 'gray' ? Colors.text.defaultDim : Colors.ut.primary)};
  text-decoration: ${props => (props.view === 'gray' ? 'underline' : 'none')};
  transition: color 0.3s, text-decoration 0.3s;
  -webkit-tap-highlight-color: ${props =>
    props.view === 'gray' ? Colors.ut.inputDown : Colors.ut.primaryDim};

  ${props =>
    props.as === 'button' &&
    css`
      cursor: pointer;
      padding: 0;
      line-height: inherit;
      background-color: transparent;
      border: 0;
      outline: 0;
    `};

  &:hover,
  &:focus {
    color: ${props => (props.view === 'gray' ? Colors.text.default : Colors.text.primaryInverse)};
    outline: ${props => props.as === 'button' && 0};
  }
`;

export default LinkText;
export { propView as typographyLinkTextPropView };
export type { PropView as TypographyLinkTextPropView };
